const setSalary = (id = null, val = null) => {
  return {
    type: 'SET_SALARY',
    id,
    data: val,
  }
}

export default {
  setSalary,
}
